// Shared inline line-icons for the list screens (Main, Contacts). Emoji render
// inconsistently across OEM fonts and are a repo rule violation, so every glyph
// is a stroke SVG that inherits `currentColor` — the parent sets the hue. The
// in-call / ring surfaces keep their own FILLED glyphs (different visual weight).

import { type ReactNode } from 'react';

/** A stroked 24×24 icon from a single path. Size via `className` (default 20px). */
export function Glyph({ d, className = 'h-5 w-5' }: { d: string; className?: string }): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

// Path data, shared so the same phone glyph reads identically everywhere.
export const PHONE_PATH =
  'M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.13.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.27a2 2 0 0 1 2.1-.45c.9.34 1.84.57 2.8.7a2 2 0 0 1 1.7 2.03z';
export const PLUS_PATH = 'M12 5v14M5 12h14';
export const USERS_PATH =
  'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21v-1a7 7 0 0 1 14 0v1M17 3.1a4 4 0 0 1 0 7.75M22 21v-1a7 7 0 0 0-4-6.3';
export const INBOX_PATH = 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM2 7l10 6 10-6';

export function PhoneGlyph({ className }: { className?: string }): ReactNode {
  return <Glyph d={PHONE_PATH} {...(className ? { className } : {})} />;
}
